import { ToastContainer } from '@postscript/components';
import React from 'react';
import styled from 'styled-components';

export const siteTitle = 'Emoji • Postscript Design System';

export const Breakpoints = {
  small: 768,
  large: 1024,
};

export const MediaQueries = {
  desktopOnly: `@media only screen and (min-width: ${Breakpoints.large + 1}px)`,
  desktopAndTablet: `@media only screen and (min-width: ${Breakpoints.small}px)`,
  tabletOnly: `@media only screen and (min-width: ${Breakpoints.small}px) and (max-width: ${Breakpoints.large}px)`,
  tabletAndPhone: `@media only screen and (max-width: ${Breakpoints.large}px)`,
  phoneOnly: `@media only screen and (max-width: ${Breakpoints.small - 1}px)`,
};

export interface MainLayoutProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

const MainLayoutContainer = styled.main<MainLayoutProps>``;

const ToastWrapper = styled.div`
  .Toastify__toast-container--bottom-center {
    bottom: var(--spacing-4);
  }
`;

const MainLayout = React.forwardRef<HTMLElement, MainLayoutProps>(
  ({ children = '', ...props }, ref) => {
    return (
      <>
        <ToastWrapper>
          <ToastContainer />
        </ToastWrapper>
        <MainLayoutContainer ref={ref} {...props}>
          {children}
        </MainLayoutContainer>
      </>
    );
  },
);

export default MainLayout;
